// @flow

export const LOAD_STUDENT: 'gobbldygook/students/LOAD_STUDENT' =
	'gobbldygook/students/LOAD_STUDENT'

export const LOAD_STUDENTS: 'gobbldygook/students/LOAD_STUDENTS' =
	'gobbldygook/students/LOAD_STUDENTS'
export const IMPORT_STUDENT: 'gobbldygook/students/IMPORT_STUDENT' =
	'gobbldygook/students/IMPORT_STUDENT'
export const DESTROY_STUDENT: 'gobbldygook/students/DESTROY_STUDENT' =
	'gobbldygook/students/DESTROY_STUDENT'

export const SAVE_STUDENT: 'gobbldygook/processed/SAVE_STUDENT' =
	'gobbldygook/processed/SAVE_STUDENT'

export const INIT_STUDENT: 'gobbldygook/processed/INIT_STUDENT' =
	'gobbldygook/processed/INIT_STUDENT'

export {CHANGE_STUDENT} from './actions/change'
